// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file app_event/appEvent/appevent.proto (package appEvent, syntax proto3)
/* eslint-disable */

import { RPC } from "../../runtime";

/**
 * @generated from message appEvent.AppEventsRequest
 */
export type AppEventsRequest = {
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 2;
 */
endDate?: string;
/**
 * @generated from field: appEvent.UserContext user_context = 3;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message appEvent.AppEventsResponse
 */
export type AppEventsResponse = {
/**
 * @generated from field: repeated appEvent.AppEvent events = 1;
 */
events?: AppEvent[];
}
;
/**
 * @generated from message appEvent.AppEvent
 */
export type AppEvent = {
/**
 * Timestamp
 *
 * @generated from field: string ts = 1;
 */
ts?: string;
/**
 * Stream
 *
 * @generated from field: string stream = 2;
 */
stream?: string;
/**
 * User name
 *
 * @generated from field: string user_name = 3;
 */
userName?: string;
/**
 * Label
 *
 * @generated from field: string label = 4;
 */
label?: string;
}
;
/**
 * @generated from message appEvent.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * @generated from rpc appEvent.AppEventService.GetAppEvents
 */
export const AppEventService_GetAppEvents = new RPC<AppEventsRequest,AppEventsResponse>("POST", "/getAppEvents");
